import { CanMatchFn } from '@angular/router';

/**
 * Matches the root route ONLY when the app is served from a "guides" subdomain
 * (e.g. guides.vegiwise.com, guides.dev.vegiwise.com).
 *
 * This lets the same SPA render the public GuidesComponent at the root of
 * guides.vegiwise.com while keeping that host in the address bar — without
 * redirecting to app.vegiwise.com.
 *
 * On any other host (app.vegiwise.com, localhost, …) it returns false, so the
 * router falls through to the normal `'' -> home` redirect. The guard is inert
 * until a `guides.*` host actually resolves.
 */
export const GuidesHostGuard: CanMatchFn = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const firstLabel = window.location.hostname.split('.')[0]?.toLowerCase() ?? '';
  return firstLabel.startsWith('guides');
};
